import React, { useState, useEffect } from "react";
import api from '../services/api';
//import { useForm, Controller } from "react-hook-form";
import "bootstrap/dist/css/bootstrap.min.css";
import { ColorBox } from "devextreme-react/color-box";
import CheckBox from "devextreme-react/check-box";
import countries from "../data/countries";
import { useAgents } from "../context/AgentContext";
import { useNavigate } from "react-router-dom";
import SelectBox from 'devextreme-react/select-box';
import { TextBox } from 'devextreme-react/text-box';
import { Link } from 'react-router-dom';


const DefaultSetting = () => {
  const [cvlayouts, setCvlayouts] = useState([]); // Initialize as empty array
  const agents = useAgents() || []; // Fallback to empty array
  const navigate = useNavigate();
  
  const [defaultSettings, setDefaultSettings] = useState({}); // Initialize as empty object
  const [settings, setSettings] = useState({}); // Initialize as empty object
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const fetchData = async () => {
      try {
        const [templatesResponse, settingsResponse] = await Promise.all([
          api.get("/CVTemplates"),
          api.get("/DefaultSettings")
        ]);
        setCvlayouts(templatesResponse.data || []);
        setDefaultSettings(settingsResponse.data || {});
      } catch (error) {
        console.error("Error fetching data:", error);
        setCvlayouts([]);
        setDefaultSettings({});
      } finally {
        setIsLoading(false);
      }
    };
    fetchData();
  }, []); 

// Initialize settings after fetching defaultSettings
useEffect(() => {
  if (defaultSettings && Object.keys(defaultSettings).length > 0) {
    setSettings({
      cvColor: defaultSettings?.cvColor || "#ffffff",
      cvFontColor: defaultSettings?.cvFontColor || "#000000",
      cvLayout: defaultSettings?.cvLayout, // Use optional chaining
      pageSize: defaultSettings?.pageSize || "ALL",
      showLetterDate: defaultSettings?.showLetterDate || false,
      enjazNoLength: defaultSettings?.enjazNoLength || 0,
      visaNoLength: defaultSettings?.visaNoLength || 0,
      passportNoLength: defaultSettings?.passportNoLength || 0,
      sponsorIDLength: defaultSettings?.sponsorIDLength || 0,
      passportExpiryMinDays: defaultSettings?.passportExpiryMinDays || 0,
      medicalExpiryMinDays: defaultSettings?.medicalExpiryMinDays || 0,
      minAge: defaultSettings?.minAge || 0,
      placeOfIssue: defaultSettings?.placeOfIssue,
      gender: defaultSettings?.gender,
      femaleSalary: defaultSettings?.femaleSalary || 0,
      femaleSalaryExp: defaultSettings?.femaleSalaryExp || 0,
      maleSalary: defaultSettings?.maleSalary || 0,
      passportType: defaultSettings?.passportType,
      religion: defaultSettings?.religion,
      maritalStatus: defaultSettings?.maritalStatus,
      currentNationality: defaultSettings?.currentNationality || "Ethiopia",
      qualification: defaultSettings?.qualification,
      femaleOccupation: defaultSettings?.femaleOccupation,
      maleOccupation: defaultSettings?.maleOccupation,
      visaType: defaultSettings?.visaType,
      sponsorAddress: defaultSettings?.sponsorAddress,
      witness1FullName: defaultSettings?.witness1FullName,
      witness2FullName: defaultSettings?.witness2FullName,
      generalManager: defaultSettings?.generalManager,
      gmTitle: defaultSettings?.gmTitle,
      witness1Address: defaultSettings?.witness1Address,
      witness2Address: defaultSettings?.witness2Address,
      witness1PhoneNo: defaultSettings?.witness1PhoneNo,
      witness2PhoneNo: defaultSettings?.witness2PhoneNo,
      displayContractDate: defaultSettings?.displayContractDate,
      officeAbroad: defaultSettings?.officeAbroad,
      displayUser: defaultSettings?.displayUser || false,
      displayBroker: defaultSettings?.displayBroker || false,
    });
  }
}, [defaultSettings]); 

// Fix 3: Prevent rendering if settings is null
if (!settings || Object.keys(settings).length === 0 || !cvlayouts || !agents) {
  return <div>Loading...</div>;
}
  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setSettings((prevSettings) => ({
      ...prevSettings,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  // Handling checkbox change
  const handleChecked = (field, value) => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      [field]: value,
    }));
  };

  const handleSettingChange = (field, value) => {
    setSettings((prevSettings) => ({
      ...prevSettings,
      [field]: value, // Dynamically update any field
    }));
  };

  //const handleSelectChange = (e) => {
  //  setSettings((prevSettings) => ({
  //    ...prevSettings,
  //    cvLayout: e.value  // Directly use e.value
  //}));
  //};

  const handleSelectChange = (e) => {
    const { name, value } = e.target || e; // Handle both DOM events and DevExtreme events
    setSettings((prevSettings) => ({ ...prevSettings, [name]: value }));
  };

  const handleDxSelect = (e) => {
    setSettings(prev => ({ ...prev, cvLayout: e.value }));
  };

  const isValidGuid = (guid) => {
    const guidRegex = /^[0-9a-fA-F]{8}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{4}-[0-9a-fA-F]{12}$/;
    return guidRegex.test(guid);
  };

  const handleSubmit = async (e) => {
    e.preventDefault();
    
    try {      
      // Prepare settings data
      const payload = {
        ...settings,
        officeAbroad: isValidGuid(settings.officeAbroad) 
          ? settings.officeAbroad 
          : "00000000-0000-0000-0000-000000000000"
      };
  
      // Make API call
      const response = await api.post('/DefaultSettings', payload);
  
      // Handle successful response
      navigate("/applicants/create", {
        state: { 
          success: true,
          message: "Default settings saved successfully"
        }
      });
  
    } catch (error) {
      console.error("Error saving default settings:", {
        message: error.message,
        status: error.response?.status,
        data: error.response?.data
      });
  
      const errorMessage = error.response?.data?.message 
        || error.message 
        || 'Failed to save default settings';
    }
  };  

  return (
    <div className="container mt-4" style={{ maxWidth: "1100px" }}>
      <div className="d-flex justify-content-between align-items-center">
    <h5 className="es-label-title">Company Settings</h5>
    {typeof window !== 'undefined' && (
      window.navigator.userAgent.includes("Firefox") ? (
        <a 
          href="https://addons.mozilla.org/firefox/downloads/file/4481143/ee2me-1.0.4.2.xpi" 
          className="es-link"
        >
          Configure
        </a>
      ) : (
        <a 
          href="https://chromewebstore.google.com/detail/ee2me/nkepfbjbmkcbbjhndocoadjflenjnchh?authuser=0&hl=en" 
          className="es-link"
        >
          Configure
        </a>
      )
    )}
  </div>

      <div className="card p-3">
        <form onSubmit={handleSubmit} className="space-y-4">
          {/* Existing fields */}
          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">CV-COLOR</label>
                <div className="col-sm-8">
                <ColorBox
                    value={settings.cvColor}
                    onValueChanged={(e) => handleSettingChange("cvColor", e.value)}
                    applyValueMode="instantly"
                    editAlphaChannel={false}
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">CV-Font-Color</label>
                <div className="col-sm-8">
                <ColorBox
                    value={settings.cvFontColor}
                    onValueChanged={(e) => handleSettingChange("cvFontColor", e.value)}
                    applyValueMode="instantly"
                    editAlphaChannel={false}
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">CV-Layout</label>
                <div className="col-sm-8">
                
                <SelectBox
                  name="cvLayout"
                  dataSource={cvlayouts}
                  value={settings.cvLayout}
                  onValueChanged={handleDxSelect}
                  displayExpr="templateName"
                  valueExpr="templateName"
                  placeholder="Select a layout"
                  itemRender={(item) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      <img 
                        src={item.imageUrl.startsWith('~') ? item.imageUrl.substring(1) : item.imageUrl}
                        alt={item.templateName}
                        style={{ width: '250px', height: '350px', marginRight: '10px', objectFit: 'contain' }}
                      />
                      <span>{item.templateName}</span>
                    </div>
                  )}
                  fieldRender={(selectedItem, fieldElement) => (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                      {selectedItem && (
                        <>
                          <img 
                            src={selectedItem.imageUrl.startsWith('~') ? selectedItem.imageUrl.substring(1) : selectedItem.imageUrl} 
                            alt={selectedItem.templateName} 
                            style={{ width: '30px', height: '30px', marginRight: '10px', objectFit: 'contain' }}
                          />
                          <TextBox
                            readOnly={true}
                            value={selectedItem.templateName}
                            elementAttr={{ class: 'dx-selectbox-input' }}
                          />
                        </>
                      )}
                      {!selectedItem && (
                        <TextBox
                          readOnly={true}
                          placeholder="Select a layout"
                          elementAttr={{ class: 'dx-selectbox-input' }}
                        />
                      )}
                    </div>
                  )}
                />


                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label"></label>
                <Link to="/cvpreferences/create" className="col-sm-8 es-link">
                  <a>Manage Agents CV Layout</a>
                </Link>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <CheckBox className="es-checkbox  es-field-label" value={settings.showLetterDate} onValueChanged={(e) => handleChecked("showLetterDate", e.value)} text="Display.Letter.Date" />
              </div>
            </div>

            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  {" "}
                  Enjaz # Length{" "}
                </label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    name="enjazNoLength"
                    value={settings.enjazNoLength}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  {" "}
                  Visa # Length{" "}
                </label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    name="visaNoLength"
                    value={settings.visaNoLength}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  {" "}
                  Passport # Length{" "}
                </label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    name="passportNoLength"
                    value={settings.passportNoLength}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  {" "}
                  Sponsor ID Length{" "}
                </label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    name="sponsorIDLength"
                    value={settings.sponsorIDLength}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  {" "}
                  Min Passport Expiry{" "}
                </label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    name="passportExpiryMinDays"
                    value={settings.passportExpiryMinDays}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  {" "}
                  Min Medical Expiry:{" "}
                </label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    name="medicalExpiryMinDays"
                    value={settings.medicalExpiryMinDays}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>

            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label"> Min Age </label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    name="minAge"
                    value={settings.minAge}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  {" "}
                  Place of Issue{" "}
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="placeOfIssue"
                    value={settings.placeOfIssue}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label"> Gender </label>
                <div className="col-sm-8">
                  <select
                    name="gender"
                    value={settings.gender}
                    onChange={handleSelectChange}
                    className="form-control"
                  >
                    <option value=""></option>
                    <option value="Male">Male</option>
                    <option value="Female">Female</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          {/* New fields */}
          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Female Salary
                </label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    name="femaleSalary"
                    value={settings.femaleSalary}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Female Salary Exp
                </label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    name="femaleSalaryExp"
                    value={settings.femaleSalaryExp}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">Male Salary</label>
                <div className="col-sm-8">
                  <input
                    type="number"
                    name="maleSalary"
                    value={settings.maleSalary}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">Passport Type</label>
                <div className="col-sm-8">
                  <select name="passportType" value={settings.passportType} onChange={handleSelectChange} className="form-control select-with-arrow" >
                    <option value=""></option>
                    <option value="Normal">Normal</option>
                    <option value="Diplomatic">Diplomatic</option>
                    <option value="Special">Special</option>
                    <option value="Haji Cert">Haji Cert</option>
                    <option value="Travel Cert">Travel Cert</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">Religion</label>
                <div className="col-sm-8">
                  <select name="religion" value={settings.religion} onChange={handleSelectChange} className="form-control select-with-arrow">
                  <option value=""></option>
                    <option value="Islam">Islam</option>
                    <option value="Christian">Christian</option>
                    <option value="Buddhism">Buddhism</option>
                    <option value="Hinduism">Hinduism</option>
                    <option value="Sikhism">Sikhism</option>
                    <option value="Non-Muslim">Non-Muslim</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Marital Status
                </label>
                <div className="col-sm-8">
                  <select name="maritalStatus" value={settings.maritalStatus} onChange={handleSelectChange} className="form-control select-with-arrow">
                    <option value=""></option>
                    <option value="Single">Single</option>
                    <option value="Married">Married</option>
                    <option value="Divorced">Divorced</option>
                    <option value="Widow">Widow</option>
                    <option value="Other">Other</option>
                  </select>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Current Nationality
                </label>
                <div className="col-sm-8">
                  <select name="currentNationality" value={settings.currentNationality} onChange={handleSelectChange} className="form-control select-with-arrow">
                    <option value="Ethiopia">Ethiopia</option>
                    {countries.map((country) => (
                      <option key={country.id} value={country.id}>
                        {country.name}
                      </option>
                    ))}
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">Qualification</label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="qualification"
                    value={settings.qualification}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Female Occupation
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="femaleOccupation"
                    value={settings.femaleOccupation}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Male Occupation
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="maleOccupation"
                    value={settings.maleOccupation}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">Visa Type</label>
                <div className="col-sm-8">
                <select name="visaType" value={settings.visaType} onChange={handleSelectChange} className="form-control select-with-arrow" >
                      <option value="Business Visit">Business Visit</option>
                      <option value="Commercial Visit">Commercial Visit</option>
                      <option value="Diplomatic">Diplomatic</option>
                      <option value="Educational">Educational</option>
                      <option value="Escort Visa">Escort Visa</option>
                      <option value="Event Visa">Event Visa</option>
                      <option value="Extend Return">Extend Return</option>
                      <option value="Family Visit">Family Visit</option>
                      <option value="Government Visit">Government Visit</option>
                      <option value="Hajj">Hajj</option>
                      <option value="Medical">Medical</option>
                      <option value="Merchandise Delivery">Merchandise Delivery</option>
                      <option value="Missions and Organizations Visit">Missions and Organizations Visit</option>
                      <option value="Personal Visit">Personal Visit</option>
                      <option value="Resident">Resident</option>
                      <option value="Seasonal Work">Seasonal Work</option>
                      <option value="Special">Special</option>
                      <option value="Temporary work">Temporary work</option>
                      <option value="Tourism">Tourism</option>
                      <option value="Transit">Transit</option>
                      <option value="Umrah">Umrah</option>
                      <option value="Work">Work</option>
                      <option value="Working Visit">Working Visit</option>
                      <option value="Other">Other</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Sponsor Address
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="sponsorAddress"
                    value={settings.sponsorAddress}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Witness 1 Full Name
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="witness1FullName"
                    value={settings.witness1FullName}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Witness 2 Full Name
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="witness2FullName"
                    value={settings.witness2FullName}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  General Manager
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="generalManager"
                    value={settings.generalManager}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">GM Title</label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="gmTitle"
                    value={settings.gmTitle}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Witness 1 Address
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="witness1Address"
                    value={settings.witness1Address}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Witness 2 Address
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="witness2Address"
                    value={settings.witness2Address}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Witness 1 Phone No
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="witness1PhoneNo"
                    value={settings.witness1PhoneNo}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Witness 2 Phone No
                </label>
                <div className="col-sm-8">
                  <input
                    type="text"
                    name="witness2PhoneNo"
                    value={settings.witness2PhoneNo}
                    onChange={handleChange}
                    className="form-control"
                  />
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Display Contract Date
                </label>
                <div className="col-sm-8">
                  <select name="displayContractDate" value={settings.displayContractDate} onChange={handleSelectChange} className="form-control select-with-arrow">
                    <option value=""></option>
                    <option value="DATE">DATE</option>
                    <option value="YEAR">YEAR</option>
                  </select>
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label es-field-label">
                  Agent
                </label>
                <div className="col-sm-8">
                <select name="officeAbroad" value={settings.officeAbroad} onChange={handleSelectChange} className="form-control select-with-arrow">                  
                    <option value="">Select...</option>
                      {agents.map(company => (
                        <option key={company.companyID} value={company.companyID}>
                          {company.companyName}
                        </option>
                      ))}
                </select>
                </div>
              </div>
            </div>
          </div>

          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label"></label>
                <div className="form-check col-sm-8">
                    <CheckBox className="es-checkbox es-field-label" value={settings.displayUser} onValueChanged={(e) => handleChecked("displayUser", e.value)} text="Display User" />
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label"></label>
                <div className="form-check col-sm-8">
                    <CheckBox className="es-checkbox es-field-label" value={settings.displayBroker} onValueChanged={(e) => handleChecked("displayBroker", e.value)} text="Display Broker" />
                </div>
              </div>
            </div>
          </div>
          
          <div className="row mb-1">
            <div className="col-md-6">
              <div className="row">
                <label className="col-sm-4 col-form-label"></label>
                <div className="form-check col-sm-8">
                    
                </div>
              </div>
            </div>
            <div className="col-md-6">
              <div className="row">
                
              </div>
            </div>
          </div>

          <div className="d-flex justify-content-end">
            <button type="submit" className="btn es-button">
              SAVE
            </button>
          </div>

        </form>
      </div>
    </div>
  );
};

export default DefaultSetting;